import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from 'components/dataTableableEdit/BaseDataTableEdit';
import { Label } from "components/input/Label";
import Estagio from 'model/producao/Estagio';
import EstagioUsuario from 'model/producao/EstagioUsuario';
import Transacao from 'model/suprimentos/Transacao';
import { Column } from 'primereact/column';
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import EstagioService from 'service/producao/EstagioService';

const estagioService = new EstagioService();

export default function EstagioCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, setFocus, register, clearErrors, setError, formState: {errors} } = useForm();

    const inputNomeRef = useRef<any>(null);

    const [estagio, setEstagio] = useState<Estagio>(new Estagio(0, "", "", []));
    const [titulo, setTitulo] = useState<string>('Estágio');
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<any[]>([]);
    const [transacoesDisponveis, setTransacoesDisponiveis] = useState<Transacao[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    useEffect(() => {
        estagioService.usuarios().then(data => {
            setUsuariosDisponiveis(data);
        }).catch(erro => {
            msgErro("Busca de usuários", erro);
        });

        estagioService.transacoes().then(data => {
            setTransacoesDisponiveis(data);
        }).catch(erro => {
            msgErro("Busca de transações", erro);
        });
    }, []);

    function validar() {

        if(!estagio.codigoEstagio) {
            setError("codigoEstagio", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        if (!estagio.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    const usuarioEditor = (options: any) => {
        return <Dropdown 
            value={options.rowData.usuario}
            options={usuariosDisponiveis} 
            filter
            optionLabel='nome'
            onChange={(e) => {
                options.rowData['usuario'] = e.target.value;
                let estagioLocal = { ...estagio };
                estagio.estagioUsuarios[options.rowIndex] = options.rowData;
                setEstagio(estagioLocal);
            }} 
            style={{ width: '100%' }} placeholder="Selecione um usuário" />;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!estagio.codigoEstagio) {
                estagioService.proximoCodigo().then((data) => {
                    setEstagio({...estagio, codigoEstagio: data});
                    setFocus("nome")
                    clearErrors("codigoEstagio")
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={estagio} service={estagioService} setModel={(value: Estagio) => setEstagio(value)} validar={() => validar()} urlService="/estagio" pathCadastro="/estagio" tituloPagina={'Estagio'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={estagio.codigoEstagio} 
                        className={errors.codigoEstagio ? "p-invalid" : ""}
                        onKeyDown={codigoKeyDown} 
                        style={{ width: '30%' }} 
                        {...register("codigoEstagio", {
                            onChange: (e) => {
                                setEstagio({ ...estagio, codigoEstagio: e.target.value })
                                clearErrors("codigoEstagio")
                            }
                        })}
                    />
                </div>
                {errors.codigoEstagio && errors.codigoEstagio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoEstagio?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={estagio.nome} 
                        className={errors.nome ? "p-invalid" : ""}
                        style={{ width: '30%' }} 
                        {...register("nome", {
                            onChange: (e) => {
                                setEstagio({...estagio, nome: e.target.value})
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Transação para saída de componentes</Label>
                <div className="col-sm-12">
                    <Dropdown 
                        options={transacoesDisponveis}
                        optionLabel='descricao'
                        value={estagio.transacao} 
                        onChange={(e) => setEstagio({ ...estagio, transacao: e.target.value })} 
                        style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Tem acerto de componente</Label>
                <div className="col-sm-12">
                    <Dropdown 
                        options={[{label: 'Sim', value: 'S'}, {label: 'Não', value: 'N'}]}
                        optionValue='value'
                        optionLabel='label'
                        value={estagio.temAcerto} 
                        onChange={(e) => setEstagio({ ...estagio, temAcerto: e.target.value })} 
                        style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Usuários</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Usuários"
                        getNewModel={() => new EstagioUsuario()}
                        dataKey="key"
                        lista={estagio.estagioUsuarios ? estagio.estagioUsuarios : []}
                        setLista={(value: any) => setEstagio({ ...estagio, estagioUsuarios: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column field="usuario.nome" header="Nome"  editor={usuarioEditor}/>
                        <Column field="usuario.email" header="Email" />
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
